const checklistUrl = process.env['NX_CHECKLIST_SCRIPT_URL'];

export const ChecklistScript = () => {
  const script = document.createElement('script');
  script.src = checklistUrl as string;
  script.type = 'text/javascript';
  return script;
};
